export { default } from './LifeOfferScreen';
